var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-card',[_c('v-card-title',{staticClass:"head title-center"},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('v-icon',{staticClass:"ml-2 mt-1",attrs:{"color":"black"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_c('Summary'),_c('Poricy'),_c('contact')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }